import styled from 'styled-components';
import { InfoListItem } from '../../Toolkit/InfoListItem/InfoListItem';
import { media } from '../../../helpers/breakpoints';

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  ${media.large} {
    padding: 0;
  }
`;

const BodyText = styled.div`
  ${({ theme }) => theme.donedeal.fontSize.B14};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const OpeningText = styled.p`
  ${({ theme }) => theme.donedeal.fontSize.M14};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
`;

const Divider = styled.div`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.donedeal.colors.GREY_LIGHT};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const ClosingText = styled.p`
  ${({ theme }) => theme.donedeal.fontSize.M14};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SInfoListItem = styled(InfoListItem)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export {
  Header,
  Divider,
  BodyText,
  OpeningText,
  ClosingText,
  ButtonContainer,
  SInfoListItem,
};
